<template>
	<div
		class="school-card my-5 test-card clearfix"
		v-show="(quiz.time < quiz.end)"
	>
			<div class="left-part">
				<div class="text-primary">
					{{
						$t('testing.test-starts', {
							day: new Date(quiz.start * 1000).getDate(),
							month: monthNames[$i18n.locale][new Date(quiz.start * 1000).getMonth()],
							year: new Date(quiz.start * 1000).getFullYear(),
							hours:
								new Date(quiz.start * 1000).getHours() < 10
									? '0' + new Date(quiz.start * 1000).getHours()
									: '' + new Date(quiz.start * 1000).getHours(),
							minutes:
								new Date(quiz.start * 1000).getMinutes() < 10
									? '0' + new Date(quiz.start * 1000).getMinutes()
									: new Date(quiz.start * 1000).getMinutes()
						})
					}}
				</div>
				<div class="text-primary">
					{{
						$t('testing.test-ends', {
							day: new Date(quiz.end * 1000).getDate(),
							month: monthNames[$i18n.locale][new Date(quiz.end * 1000).getMonth()],
							year: new Date(quiz.end * 1000).getFullYear(),
							hours:
                new Date(quiz.end * 1000).getHours() < 10
									? '0' + new Date(quiz.end * 1000).getHours()
									: new Date(quiz.end * 1000).getHours(),
							minutes:
								new Date(quiz.end * 1000).getMinutes() < 10
									? '0' + new Date(quiz.end * 1000).getMinutes()
									: '' + new Date(quiz.end * 1000).getMinutes()
						})
					}}
				</div>
				<h2 class="mb-1">{{ quiz[`title_${$i18n.locale}`] }}</h2>
				<div class="test-status">
					<svg
						class="mr-2"
						width="15"
						height="15"
						viewBox="0 0 15 15"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M7.5 14.5797L7.91108 14.2208C11.3679 11.2023 13.125 8.56672 13.125 6.25C13.125 2.96916 10.5643 0.625 7.5 0.625C4.43566 0.625 1.875 2.96916 1.875 6.25C1.875 8.56672 3.63207 11.2023 7.08892 14.2208L7.5 14.5797ZM7.5 12.9146C4.56663 10.271 3.125 8.03077 3.125 6.25C3.125 3.68538 5.10257 1.875 7.5 1.875C9.89743 1.875 11.875 3.68538 11.875 6.25C11.875 8.03077 10.4334 10.271 7.5 12.9146ZM7.5 3.125C9.22589 3.125 10.625 4.52411 10.625 6.25C10.625 7.97589 9.22589 9.375 7.5 9.375C5.77411 9.375 4.375 7.97589 4.375 6.25C4.375 4.52411 5.77411 3.125 7.5 3.125ZM5.625 6.25C5.625 5.21447 6.46447 4.375 7.5 4.375C8.53553 4.375 9.375 5.21447 9.375 6.25C9.375 7.28553 8.53553 8.125 7.5 8.125C6.46447 8.125 5.625 7.28553 5.625 6.25Z"
							fill="black"
						/>
					</svg>
					<span>{{ $t('testing.test-place') }} {{ $t('testing.online') }}</span>
				</div>
				<div class="test-status">
					<svg
						class="mr-2"
						width="15"
						height="15"
						viewBox="0 0 15 15"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M7.5 0.625C11.297 0.625 14.375 3.70304 14.375 7.5C14.375 11.297 11.297 14.375 7.5 14.375C3.70304 14.375 0.625 11.297 0.625 7.5C0.625 3.70304 3.70304 0.625 7.5 0.625ZM13.0757 8.24784C12.4131 8.59245 11.5404 8.88061 10.5495 9.07928C10.4087 10.518 10.0755 11.7881 9.59091 12.7236C11.4403 11.9826 12.8047 10.2879 13.0757 8.24784ZM9.36643 8.00277C9.37209 7.83726 9.375 7.66957 9.375 7.5C9.375 4.365 8.379 1.875 7.5 1.875C6.621 1.875 5.625 4.365 5.625 7.5C5.625 7.67932 5.62826 7.85652 5.63457 8.03127C6.22096 8.09258 6.84755 8.12491 7.50031 8.12491C8.14273 8.12491 8.77305 8.07961 9.36643 8.00277ZM10.6226 7.78381C10.6242 7.68965 10.625 7.59504 10.625 7.5C10.625 5.42022 10.2465 3.54206 9.59091 2.27644C11.4511 3.02172 12.8206 4.73185 13.0803 6.78781C12.7859 7.11789 11.8583 7.5099 10.6226 7.78381ZM5.7368 9.29821C6.29759 9.34874 6.88824 9.37491 7.50031 9.37491C8.10228 9.37491 8.69538 9.3408 9.26581 9.27753C8.98389 11.526 8.20438 13.125 7.5 13.125C6.79778 13.125 6.02089 11.5358 5.7368 9.29821ZM4.37847 7.84374C4.01986 7.77219 3.68564 7.68794 3.38047 7.59211C2.60483 7.34853 2.09807 7.04997 1.91608 6.81671C2.16661 4.74789 3.5402 3.02521 5.40909 2.27644C4.75348 3.54206 4.375 5.42022 4.375 7.5C4.375 7.61522 4.37616 7.72982 4.37847 7.84374ZM4.4557 9.13163C4.59945 10.5489 4.9304 11.7995 5.40909 12.7236C3.59165 11.9954 2.24261 10.3462 1.93931 8.35335C2.59146 8.69308 3.45203 8.95714 4.4557 9.13163Z"
							fill="black"
						/>
					</svg>
					<span v-show="test_lang === 'ru'"
						>{{ $t('testing.test-language') }}
						{{ $t('testing.russian-lang') }}</span
					>
					<span v-show="test_lang === 'kz'"
						>{{ $t('testing.test-language') }}
						{{ $t('testing.kazakh-lang') }}</span
					>
				</div>
        <div class="mt-3">
          {{quiz[`description_${$i18n.locale}`]}}
        </div>
			</div>
			<div class="right-part">
        <div class="test-tries-left">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 6.84375C15.5 6.84375 16.6419 6.28125 12.5 6.28125C11.0166 6.28125 9.5666 6.72112 8.33323 7.54523C7.09986 8.36934 6.13856 9.54068 5.57091 10.9111C5.00325 12.2816 4.85472 13.7896 5.14411 15.2444C5.4335 16.6993 6.14781 18.0357 7.1967 19.0846C8.2456 20.1334 9.58197 20.8478 11.0368 21.1371C12.4917 21.4265 13.9997 21.278 15.3701 20.7103C16.7406 20.1427 17.9119 19.1814 18.736 17.948C19.5601 16.7147 20 15.2646 20 13.7812" stroke="#E24C4B" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M12.5 2.71875L16.25 6.46875L12.5 10.2188" stroke="#E24C4B" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          {{$t('testing.test-tries', { tries: quiz.quiz_tries - quiz.user_tries})}}
        </div>
				<div class="btn-wrap">
					<el-button
						@click="getToken(quiz.id)"
						:disabled="quiz.disabled || (quiz.start > quiz.time) || quiz.is_start === false"
						:loading="btnLoading"
						class="btn btn-primary"
						>{{
							quiz.started
								? $t('testing.test-resume-btn')
								: $t('testing.test-begin-btn')
						}}</el-button
					>
					<div
						v-if="quiz.start > quiz.time"
						class="hint text-danger"
					>
						{{
							leftTimeToStart | duration('h:mm:ss') | duration('humanize', true)
						}}
					</div>
					<div class="text-primary" v-if="quiz.disabled">
						{{
							$t('testing.test-tries-exhausted')
						}}
					</div>
					<div class="text-danger" v-if="quiz.is_start === false">
						{{
							$t('testing.test-region-unavailable', {
								from_day: new Date(quiz.region_from).getDate(),
								from_month: monthNames[$i18n.locale][new Date(quiz.region_from).getMonth()],
								from_year: new Date(quiz.region_from).getFullYear(),
								from_hours: new Date(quiz.region_from).getHours() < 10
									? '0' + new Date(quiz.region_from).getHours()
									: '' + new Date(quiz.region_from).getHours(),
								from_minutes: new Date(quiz.region_from).getMinutes() < 10
									? '0' + new Date(quiz.region_from).getMinutes()
									: '' + new Date(quiz.region_from).getMinutes(),
								to_day: new Date(quiz.region_to).getDate(),
								to_month: monthNames[$i18n.locale][new Date(quiz.region_to).getMonth()],
								to_year: new Date(quiz.region_to).getFullYear(),
								to_hours: new Date(quiz.region_to).getHours() < 10
									? '0' + new Date(quiz.region_to).getHours()
									: '' + new Date(quiz.region_to).getHours(),
								to_minutes: new Date(quiz.region_to).getMinutes() < 10
									? '0' + new Date(quiz.region_to).getMinutes()
									: '' + new Date(quiz.region_to).getMinutes()
							})
						}}
					</div>
					<!--<a href="school.html" data-toggle="modal" data-target="#claim-modal" type="button" class="btn btn-outline-primary">Подать заявку</a> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MobileDetect from 'mobile-detect';
import Vue from "vue";
	export default {
		props: {
			quiz: {
				type: Object,
				require: true
			},
			test_lang: {
				type: String,
				require: true
			}
		},
		data() {
			return {
				monthNames: {
					ru: [
						'января',
						'февраля',
						'марта',
						'апреля',
						'мая',
						'июня',
						'июля',
						'августа',
						'сентября',
						'октября',
						'ноября',
						'декабря'
					],
					kz: [
						'қаңтарда',
						'ақпанда',
						'наурызда',
						'сәуiрде',
						'мамырда',
						'маусымда',
						'шiлдеде',
						'тамызда',
						'қыркүйекте',
						'қазанда',
						'қарашада',
						'желтоқсанда'
					]
				},
				leftTimeToStart: '',
				timerInterval: null,
				btnLoading: false,
				testStarted: false,
        isMobile: false
			}
		},
		methods: {
			startTimer() {
				this.timerInterval = setInterval(() => {
					this.leftTimeToStart = new Date(this.quiz.start * 1000) - new Date()
				}, 60000)
			},
			getToken(id){

        if (this.isMobile) {
          Vue.toastr({
            message: this.$t('error'),
            description: this.$t('only_desktop'),
            type: 'error'
          })
          return;
        }

				const { region_id } = JSON.parse(localStorage.getItem('user'))
				this.btnLoading = true
				console.log(this.btnLoading);
        const user = JSON.parse(localStorage.getItem('user'))
				if (region_id) {
					this.$http.get(API_ROOT + '/api/olympiad/link?quiz_id=' + id, {
						params: {
							region_id
						}
					})
					.then((res) => {
						this.btnLoading = false
						if (res.body.link){
							window.location = QUIZ_ROOT + '/rules/' + res.body.token + `?iin=${user.iin}`;
						}
					}).catch((e) => {
							Vue.toastr({
                message: this.$t('error'),
								description: e.body,
								type: 'error'
							})
					});
				} else {
					Vue.toastr({
						message: '',
						description: 'Попробуйте позже',
						type: 'info'
					})
				}
				this.$http.get(API_ROOT + '/api/olympiad/link?quiz_id=' + id)
				.then((res) => {
					this.btnLoading = false
					if (res.body.link){
						window.location = QUIZ_ROOT + '/rules/' + res.body.token + `?iin=${user.iin}`;
					}
				}).catch((e) => {
						Vue.toastr({
              message: this.$t('error'),
							description: e.body,
							type: 'error'
						})
				});
			},
		},
		beforeDestroy() {
			clearInterval(this.timerInterval)
		},
		mounted() {
			this.leftTimeToStart = new Date(this.quiz.start * 1000) - new Date()
			this.startTimer();
      let currentTimestamp = (+ new Date());
			let quizStartTime = ( + new Date(this.quiz.start));
			if (currentTimestamp > quizStartTime) {
				this.testStarted = true
			}

      const md = new MobileDetect(window.navigator.userAgent);
      this.isMobile = !!(md.mobile() || md.tablet());
		}
	}
</script>

<style scoped lang="scss">
	@media screen and (max-width: 678px) {
		.school-card.test-card {
			padding: 32px 19px !important;
			.text-primary {
				font-size: 12px;
			}
			h2 {
				font-size: 22px;
			}
		}
	}
</style>
